import React, { useCallback, useState } from 'react';
import { styled } from '@compiled/react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { token } from '@atlaskit/tokens';
import { useActions } from '../../../store/converse';
import { ClearConversationModal } from '../clear-conversation-modal';
import messages from './messages';

export const ClearConversation = () => {
    const { formatMessage } = useIntl();
    const { clearConversation } = useActions();
    const [isModalVisible, setModalVisibility] = useState(false);
    const openModal = useCallback(() => setModalVisibility(true), []);
    const closeModal = useCallback(() => setModalVisibility(false), []);

    return (
        <>
            <ClearConversationButton onClick={openModal}>
                {formatMessage(messages.clearConversationButton)}
            </ClearConversationButton>

            <ModalTransition>
                {isModalVisible && (
                    <ClearConversationModal onClose={closeModal} onClearButtonClick={clearConversation} />
                )}
            </ModalTransition>
        </>
    );
};

const ClearConversationButton = styled(Button)({
    position: 'fixed',
    right: token('space.400', '32px'),
    top: token('space.1000', '80px'),
    backgroundColor: token('color.background.neutral.subtle', '#091E420F'),
});
